/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from "react";
import { div, Text, StyleSheet, Font } from "@react-pdf/renderer";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

const styles = StyleSheet.create({
  mainheader: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    padding: "0.5in",
  },
  subheader: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    width: "100%",
  },
  lessontitle: {
    fontSize: "10pt",
    textAlign: "left",
    flexGrow: 1,
    color: "#666666",
  },
  label: {
    fontSize: "10pt",
    textAlign: "right",
    color: "#666666",
  },
  header: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    width: "100%",
  },
  title: {
    fontSize: "12pt",
    textAlign: "left",
    flexGrow: 1,
  },
  subtitle: {
    fontSize: "12pt",
    textAlign: "right",
  },
});

const Header = (props) => {
  const { course, lesson, section, page } = props;

  // remove tab from the title
  const pagetitle = page?.title ? page.title.replace(/\t/g, "") : "";

  return (
    <>
      <Typography className="text-24 font-bold px-16 mb-16">
        {pagetitle}
      </Typography>
      <Grid container spacing={2} className="w-full mb-24 px-16">
        <Grid item xs={4}>
          <Typography className="text-md font-semibold leading-5">
            Course: {course.label}
          </Typography>
          <Typography className="mt-2 text-md line-clamp-2 text-secondary">
            {course.title}
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography className="text-md font-semibold leading-5">
            Lesson: {lesson.label}
          </Typography>
          <Typography className="mt-2 text-md line-clamp-2 text-secondary">
            {lesson.title}
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography className="text-md font-semibold leading-5">
            Section: {section.label}
          </Typography>
          <Typography className="mt-2 text-md line-clamp-2 text-secondary">
            {section.title}
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography className="text-md font-semibold leading-5">
            Page Number:
          </Typography>
          <Typography className="mt-2 text-md line-clamp-2 text-secondary">
            {page.pageNumber}
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography className="text-md font-semibold leading-5">
            Page Back:
          </Typography>
          <Typography className="mt-2 text-md line-clamp-2 text-secondary">
            {page.prevPage}
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography className="text-md font-semibold leading-5">
            Page Next:
          </Typography>
          <Typography className="mt-2 text-md line-clamp-2 text-secondary">
            {page.nextPage}
          </Typography>
        </Grid>
      </Grid>
    </>
  );
};

export default Header;
